module.exports = __webpack_public_path__ + "images/icons/icon-add-3b85008f.svg";